import Box from "@mui/material/Box";
import {
  actionMenuToggled,
  actionMenuSearchTypeToggled,
  actionMenuSearchUpdateChanged,
} from "./AppBarRedux";
import { useDispatch, useSelector } from "react-redux";

import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";

import Floor from "./Floor";
import Menu from "./Menu";
import { actionDataSearchRooms } from "../Data";
import {
  actionSearchVisibleToggled,
  BuildingMenu,
  RoomMenu,
  PeopleMenu,
  DepartmentMenu,
  RoomtypeMenu,
} from "../Search";
import { trackEvent } from "../../tracking";

// const umichBlue = '#00274c';

const root_ = (theme) => ({
  position: "fixed",
  left: 5,
  top: 5,
  padding: "2px 4px",
  display: "flex",
  alignItems: "center",
  width: 352,
  minHeight: 48,
  opacity: 0.975,
  zIndex: 1,
  [theme.breakpoints.down("sm")]: {
    top: 4,
    left: "50%",
    width: 330,
    minHeight: 40,
    padding: "1px",
    transform: "translate(-50%, 0)",
    opacity: 0.9,
  },
});

const menuBtn_ = (theme) => ({
  // 44x44 min size is needed to meet this accessibility requirement:
  // https://www.w3.org/WAI/WCAG22/Understanding/target-size-enhanced.html
  width: 44,
  height: 44,
  borderRadius: "0px",
  padding: "6px",
  paddingRight: "10px",
  color: "rgba(0, 0, 0, 0.87)",
  "& .MuiSvgIcon-root": {
    fontSize: "1.8rem",
  },
  [theme.breakpoints.down("sm")]: {
    paddingLeft: "12px",
    paddingRight: "14px",
  },
});

const searchBtn_ = (theme) => ({
  color: "rgba(0, 0, 0, 0.87)",
  backgroundColor: "transparent",
  boxShadow: "none",
  borderLeft: "1px solid lightgrey",
  borderRadius: "0px",
  width: "100%",
  lineHeight: 2.1,
  [theme.breakpoints.down("sm")]: {
    width: "60%",
    lineHeight: 2,
    borderRight: "1px solid lightgrey",
  },
});

const grid_ = (theme) => ({
  display: "flex",
  alignItems: "center",
});

const gridLeft_ = (theme) => ({
  // width: '30%',
  width: "13%",
  // [theme.breakpoints.down('xs')]: {
  //   width: '15%',
  // }
});

const gridRight_ = (theme) => ({
  // width: '70%',
  width: "87%",
  // [theme.breakpoints.down('xs')]: {
  //   width: '85%',
  // }
});

const floor_ = (theme) => ({
  left: 360,
  position: "fixed",
  backgroundColor: "white",
  borderRadius: "5px",
  boxShadow: theme.shadows[1],
  [theme.breakpoints.down("sm")]: {
    position: "fixed",
    left: 240,
    boxShadow: theme.shadows[0],
  },
});

export default function CustomizedInputBase() {
  const searchType = useSelector((state) => state.appBarReducer.searchType);
  const updateSearch = useSelector((state) => state.appBarReducer.updateSearch);
  const dispatch = useDispatch();

  const menuClickedHandler = () => {
    dispatch(actionMenuToggled());
    trackEvent({
      category: "User Interaction",
      action: "Left Menu",
    });
  };

  const selectHandler = (data) => {
    dispatch(actionDataSearchRooms(data, updateSearch));
    dispatch(actionMenuSearchTypeToggled(data.type));
    dispatch(actionMenuSearchUpdateChanged(null));
  };

  const onCloseHandler = (menuType) => {
    dispatch(actionMenuSearchTypeToggled(menuType));
  };

  return (
    <Box>
      <Paper sx={root_}>
        <Grid container spacing={0}>
          <Grid sx={[grid_, gridLeft_]}>
            <Tooltip title="Menu">
              <IconButton
                sx={menuBtn_}
                aria-label="menu"
                onClick={menuClickedHandler}
                size="large"
              >
                <MenuIcon />
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid sx={[grid_, gridRight_]}>
            <Tooltip
              title="Search for Building, Room, Person and more"
              // The Tooltip text will appear in an "aria-label" attribute.
              // By adding this role, we create a "Role Region":
              // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/region_role
              // This avoids a "Text not included in an ARIA landmark" complaint in the
              // Siteimprove browser plugin.
              role="region"
            >
              <Button
                disableRipple
                onClick={() => dispatch(actionSearchVisibleToggled())}
                sx={searchBtn_}
                endIcon={<SearchIcon />}
              >
                Search
              </Button>
            </Tooltip>
            <Box sx={floor_}>
              <Floor />
            </Box>
          </Grid>
        </Grid>
      </Paper>
      <Menu />
      <BuildingMenu
        visible={searchType === "building"}
        selectHandler={selectHandler}
        onCloseHandler={onCloseHandler}
      />
      <RoomMenu
        visible={searchType === "room"}
        selectHandler={selectHandler}
        onCloseHandler={onCloseHandler}
      />
      <PeopleMenu
        visible={searchType === "person"}
        selectHandler={selectHandler}
        onCloseHandler={onCloseHandler}
      />
      <DepartmentMenu
        visible={searchType === "department"}
        selectHandler={selectHandler}
        onCloseHandler={onCloseHandler}
      />
      <RoomtypeMenu
        visible={searchType === "roomtype"}
        selectHandler={selectHandler}
        onCloseHandler={onCloseHandler}
      />
    </Box>
  );
}
